import { defineStyle } from "@chakra-ui/react";

export const DoubtStyles = () => {
  return {
    doubtContainer: defineStyle({
      display: "grid",
      gridTemplateColumns: "repeat(14,1fr)",
      gap: "24px",
    }),
    subContainer: defineStyle({
      gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
      flexDirection: "column",
    }),
  };
};
